<template>
  <relatie-units 
    v-if="unit && relatie !== null"
    :relatie="relatie" 
    :relatie-id="relatieId"
  />
</template>
<script>
import RelatieUnits from '@/views/settings/RelatieUnitsOverzicht'
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
    name: 'TabRelatie',
    components: { RelatieUnits },
    mixins: [serviceMixin],
    props: {
        unit: {
            type:Object,
            default:() => null
        },
    },
    data() {
        return {
            relatie: null,
        }
    },
    computed: {
      relatieId: function() {
        return this.unit.Complex.Relatie.Id
      },
    },
    mounted() {
        this.getRelatie();
    },
    methods: {
      getRelatie() {
        var vm = this;
        this.get(`/relaties/${this.relatieId}`)
          .then(function(response) {
            vm.relatie = response.data.relatie;
          })
          .catch(function( error ) {
            console.log("Error --" , error);
          });
      },
    }
}
</script>
